export default [
  { description: 'All', code: 'all', id: 4 },
  { description: 'Department', code: 'department', id: 2 },
  { description: 'Union', code: 'union', id: 1 },
  { description: 'Location', code: 'location', id: 3 },
  { description: 'Combo', code: 'combo', id: 5 },
];
